import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/EmptyState/empty-state.mjs';
export const EmptyStateActions = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (_jsx("div", Object.assign({ className: css(styles.emptyStateActions, className) }, props, { children: children })));
};
EmptyStateActions.displayName = 'EmptyStateActions';
//# sourceMappingURL=EmptyStateActions.js.map